import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=4b8c7e88&scoped=true"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=4b8c7e88&prod&lang=scss&scoped=true"
import style1 from "./VerticalNavMenuItem.vue?vue&type=style&index=1&id=4b8c7e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c7e88",
  null
  
)

export default component.exports